import type { ContainersFragment } from '@seek/cmsu-cms-connect';

/**
 * Checks if a container should have a divider between it and the next container.
 */
export const hasDivider = (
  containers: ContainersFragment[],
  currentIndex: number,
): boolean => {
  const thisContainer = containers[currentIndex];
  const nextContainer = containers[currentIndex + 1];

  // Don't add a divider if this or the next container have a background
  if (thisContainer?.box?.background || nextContainer?.box?.background) {
    return false;
  }

  // Don't add a divider if we are on the last container
  if (currentIndex === containers.length - 1) {
    return false;
  }

  return true;
};
